export const CHECKOUT_URL = 'https://hyrox-train.impultienda.ar/checkout'

export const PRICE_USD = 25
